import React from 'react';
// TODO: /account/auth/register and /account/auth/login point to the legacy
// MVC auth pages. This means pages like the marketing trimmer, recorder and
// other features will route to this page. Investigate unifying our landing
// page for account creation.
export const SignUpGate = (props) => {
    const encodedReturnUrlParam = props.returnUrl ? `ReturnUrl=${encodeURIComponent(props.returnUrl)}` : '';
    return (React.createElement("div", { id: "signup-gate", className: "card pv3" },
        React.createElement("div", { className: "w-100 w-80-ns center pv4 ph4" },
            React.createElement("div", { className: "f3 f2-ns fw5 dark-gray pb2" },
                "Thank you for using our ",
                props.toolName,
                "!"),
            React.createElement("div", { className: "lh-copy dark-gray pv3" },
                "You have reached the ",
                React.createElement("b", null, "usage limit"),
                " for this tool. To continue using the",
                ' ',
                props.toolName.toLowerCase(),
                ", please create a free Rev account."),
            React.createElement("div", { className: "lh-copy dark-gray pt3 pb4" }, "There is no cost associated with creating an account or using this tool"),
            React.createElement("a", { id: "signup-button", type: "button", className: "button-green mv1 mh2 ttu button-large fw5 white", href: `/account/auth/register?${encodedReturnUrlParam}` }, "create an account"),
            React.createElement("div", { className: "lh-copy dark-gray pt3 b" },
                "Already have an account?",
                ' ',
                React.createElement("a", { id: "login-link", className: "text-link blue", href: `/account/auth/login?${encodedReturnUrlParam}` }, "Login here.")))));
};
